import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';

const MIN_REFRESH_MS = 30000; // 30 seconds

export interface Auth {
  orgId?: string;
  roleIds?: [RoleId];
  scope?: [RoleId];
  userId?: string;
  saganUser?: string;
  exp?: number;
  iat?: number;
}

export class AuthUtils {
  static getRefreshDurationMS(auth: Auth): number {
    // Tokens must be valid for > 30 seconds
    const leaseSec = get(auth, 'exp', 0) - get(auth, 'iat', 0);
    const refreshMS = Math.floor(leaseSec * 0.01) * 1000;
    return Math.max(refreshMS, MIN_REFRESH_MS);
  }

  static isLoggedIn(auth: Auth): boolean {
    return !isEmpty(auth) && get(auth, 'exp', 0) > moment().unix();
  }
}

const RoleIds = [
  'agent',
  'agent-plus',
  'analyst',
  'answers-admin',
  'task-user',
  'api-user',
  'system-admin',
  'team-manager',
  'liveboards',
] as const;

type RoleId = (typeof RoleIds)[number];
